import { render, staticRenderFns } from "./people-item.vue?vue&type=template&id=0a2ad990&scoped=true&"
import script from "./people-item.vue?vue&type=script&lang=js&"
export * from "./people-item.vue?vue&type=script&lang=js&"
import style0 from "./people-item.vue?vue&type=style&index=0&id=0a2ad990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2ad990",
  null
  
)

export default component.exports